// extracted by mini-css-extract-plugin
module.exports = {"root":"UnpaidInvoicesPage_root__22u0Q","loading":"UnpaidInvoicesPage_loading__XA281"};